var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "start" },
    [
      _c("v-cover", {
        attrs: {
          image: _vm.coverImage,
          title: _vm.$t("startPage.titre"),
          description: _vm.$t("startPage.bulyDescription"),
          cta: _vm.$t("startPage.bulyCta"),
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }